import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';

import type { User, UserBase, UserWithRole } from '@recruitee/account-types';
import { TranslatePipe } from '@recruitee/i18n';
import {
  IconButtonComponent,
  DividerComponent,
  TruncateComponent,
  HeadingComponent,
  AvatarComponent,
  CheckboxComponent,
} from '@recruitee/user-interface';

import { RoleWithAdmins } from '../../../../types';

@Component({
  selector: 'rt-visibility-admin-item',
  templateUrl: 'visibility-admin-item.component.html',
  styleUrls: ['./visibility-admin-item.component.less'],
  standalone: true,
  imports: [
    CheckboxComponent,
    ReactiveFormsModule,
    AvatarComponent,
    HeadingComponent,
    TruncateComponent,
    DividerComponent,
    IconButtonComponent,
    TranslatePipe,
  ],
})
export class VisibilityAdminItemComponent {
  @Input() public admin: UserWithRole;
  @Input() public currentAdmin: UserBase;
  @Input() public hasDivider: boolean = false;
  @Input() public hasNoBorderBottom: boolean = false;
  @Input() public hasPadding: boolean = false;
  @Input() public hasCheckboxOffset: boolean = false;
  @Input() public kind: 'admin' | 'role' | 'simple-admin' | 'no-access' = 'admin';
  @Input() public form: UntypedFormControl | null;
  @Input() public checked: false | number;
  @Input() public roleWithAdmins: RoleWithAdmins | null = null;
  @Input() public roleAssignmentsGroup: { [roleId: string]: number | false } | null = null;
  @Input() public groupUsersByAccess = false;

  @Output() public checkboxClick: EventEmitter<void> = new EventEmitter();
  @Output() public toggleAssignment: EventEmitter<User | RoleWithAdmins> = new EventEmitter();

  public expanded: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  public toggleList($event: MouseEvent): void {
    $event.stopPropagation();
    this.expanded = !this.expanded;
    this.cdRef.detectChanges();
  }

  public trackById<T extends { id: number }>(index: number, { id }: T): number {
    return id;
  }
}
